var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_15516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5827 9.99867C19.5827 4.67359 15.2921 0.356771 9.99935 0.356771C4.70662 0.356771 0.416016 4.67359 0.416016 9.99867C0.416016 14.8112 3.9205 18.8001 8.50195 19.5234V12.7858H6.06868V9.99867H8.50195V7.87444C8.50195 5.45794 9.93268 4.12314 12.1217 4.12314C13.1702 4.12314 14.2669 4.31146 14.2669 4.31146V6.68427H13.0585C11.868 6.68427 11.4967 7.4275 11.4967 8.19V9.99867H14.1546L13.7297 12.7858H11.4967V19.5234C16.0782 18.8001 19.5827 14.8112 19.5827 9.99867Z",
    fill: "#1877F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_15516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.d9dc9e4093a13d0dd68ee955dc410b7a.svg";
export { ForwardRef as ReactComponent };